<template>
  <div>
    <h1>{{ $t("delegation.decision.title") }}</h1>
    <div class="mt-3 elevation-12 grey lighten-4">
      <div class="pa-4">
        <delegation-decision-form
          :delegation-decision.sync="delegationDecision"
          @accept="accept"
          @deny="deny"
          @denyAndRevert="denyAndRevert"
          @downloadAllFiles="downloadAttachments"
          @downloadSettlement="downloadSettlement"
          @settle="settle"
        >
        </delegation-decision-form>
      </div>
      <v-card class="grey lighten-4">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="$router.push('/delegation')" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import fileDownloadFunction from "../../repository/downloadFile";
import DelegationDecisionForm from "../../components/Delegation/DelegationDecisionForm";

export default {
  name: "DelegationDecisionView",
  components: { DelegationDecisionForm },
  data: () => ({
    delegationDecision: {
      additionalCostsShow: false
    }
  }),
  created() {
    // if (!(this.$route.params.type === 'financial' || this.$route.params.type === 'substantial')) {
    //     this.$router.push('/delegation');
    // }
    this.downloadDelegationDecision();
  },
  methods: {
    downloadSettlement() {
      fileDownloadFunction("delegation/document-preview?id=" + this.$route.params.id);
    },
    downloadAttachments() {
      fileDownloadFunction("delegation/all-files?id=" + this.$route.params.id);
    },
    downloadDelegationDecision() {
      this.axios.get("delegation/get-decision?delegationId=" + this.$route.params.id).then(resp => {
        this.delegationDecision = resp.data;
      });
    },
    accept() {
      this.axios({
        url: "delegation/accept",
        data: { id: this.$route.params.id },
        method: "POST"
      })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$router.push("/delegation");
          } else if (resp.data.status === "error") {
            //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
          }
        })
        .catch(() => {
          //TODO obsluga bledow
        });
    },
    settle() {
      this.axios({
        url: "delegation/settle",
        data: { id: this.$route.params.id },
        method: "POST"
      })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$router.push("/delegation");
          } else if (resp.data.status === "error") {
            //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
          }
        })
        .catch(() => {
          //TODO obsluga bledow
        });
    },
    deny(promptText) {
      this.axios({
        url: "delegation/reject",
        data: {
          id: this.$route.params.id,
          reason: promptText
        },
        method: "POST"
      })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$router.push("/delegation");
          } else if (resp.data.status === "error") {
            //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
          }
        })
        .catch(() => {
          //TODO obsluga bledow
        });
    },
    denyAndRevert(promptText) {
      this.axios({
        url: "delegation/reject-and-back",
        data: {
          id: this.$route.params.id,
          reason: promptText
        },
        method: "POST"
      })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$router.push("/delegation");
          } else if (resp.data.status === "error") {
            //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
          }
        })
        .catch(() => {
          //TODO obsluga bledow
        });
    }
  },
  mounted() {
    this.$store.dispatch("Visual/setHalfBackground");
  },
  beforeDestroy() {
    this.$store.dispatch("Visual/setWhiteBackground");
  }
};
</script>

<style scoped></style>
